import React, { useContext, useEffect } from "react";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

//Material UI stuff
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

//helper functions
import { connectCluster } from "./helpers";

const ClusterRowInfoConnect = ({ clusterInfo }) => {
  //access global state to update weaviate uri
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //it runs to connect to the cluster
  const handleClick = () => {
    connectCluster(state, setState, clusterInfo);
  };

  useEffect(() => {
    //it disconnects the current cluster if for some reason
    //it went back to provisioning state
    if (
      state.connectToWeaviateURI ===
        `https://${clusterInfo.data.meta.PublicURL}` &&
      clusterInfo.data.status.state.percentage !== 100
    ) {
      setState({ ...state, connectToWeaviateURI: "" });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusterInfo.data.status.state.percentage, state.connectToWeaviateURI]);

  //This will display either a disabled button if the cluster is still provisioning
  //or a enabled button so the user can connect to that cluster
  return (
    <TableCell
      align="left"
      style={{
        borderBottom:
          state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      {clusterInfo.data.status.state.percentage === 100 ? (
        <button
          style={{
            background: "transparent",
            color:
              state.connectToWeaviateURI ===
              `https://${clusterInfo.data.meta.PublicURL}`
                ? "#38d611"
                : state.theme === "dark"
                ? "#fff"
                : "#00152b",
            border:
              state.connectToWeaviateURI ===
              `https://${clusterInfo.data.meta.PublicURL}`
                ? "1px solid #38d611"
                : state.theme === "dark"
                ? "1px solid #fff"
                : " 1px solid #00152b",
          }}
          onClick={handleClick}
          className={
            state.theme === "dark"
              ? "__connectToClusterButtonDesktop __connectToClusterButtonDesktopDark"
              : "__connectToClusterButtonDesktop __connectToClusterButtonDesktopLight"
          }
        >
          {state.connectToWeaviateURI ===
          `https://${clusterInfo.data.meta.PublicURL}`
            ? "CONNECTED"
            : "CONNECT"}
        </button>
      ) : (
        <Tooltip
          title="Cluster needs to be ready in order to connect."
          placement="bottom"
        >
          <button
            style={{
              background: "transparent",
              color: "#ababab",
              border: "1px solid #ababab",
            }}
            className="__connectToClusterButtonDesktopDisabled"
          >
            CONNECT
          </button>
        </Tooltip>
      )}
    </TableCell>
  );
};

export default ClusterRowInfoConnect;
